document.addEventListener('click', function(event) {
  const swatch = event.target.closest('.product-card__swatch');
  if (!swatch) return;

  const imageUrl = swatch.dataset.variantImage;
  if (!imageUrl) return;

  const card = swatch.closest('.card, .product-card, li');
  if (!card) return;

  const image = card.querySelector('img');

  if (image) {
    image.src = imageUrl;
    image.srcset = imageUrl;
  }
});